import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WebcamImage } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';

enum ActionTypesEnum {
  CANCEL,
  DIRECTORY,
  CAMERA,
}

@Component({
  selector: 'app-device-type-select-dialog',
  templateUrl: './device-type-select-dialog.component.html',
  styleUrls: ['./device-type-select-dialog.component.sass'],
})
export class DeviceTypeSelectDialogComponent implements OnInit {
  showWebcan: boolean = false;
  private trigger: Subject<void> = new Subject<void>();
  public webcamImage: WebcamImage | undefined;
  image: string | null = null;

  imageFromInjected: boolean = false;
  @ViewChild('uploadFileSelect') uploadFile: ElementRef<HTMLInputElement> | undefined;

  constructor(
    public dialogRef: MatDialogRef<DeviceTypeSelectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    if (this.data) {
      const injected = this.data.image ?? this.data.imageUrl;
      if (injected) this.image = injected;
  if (injected) this.imageFromInjected = true;
    }
  }

  cancel() {
    this.dialogRef.close({ type: ActionTypesEnum.CANCEL });
  }

  ok() {
    this.dialogRef.close({ image: this.image });
  }

  findImage() {
    this.uploadFile?.nativeElement?.click();
  }

  upload(event: any) {
    const element = event.currentTarget as HTMLInputElement;
    const fileList: FileList | null = element.files;

    if (fileList && fileList.length > 0) {
      const file = fileList[0];
      this.readFileAsDataUrl(file)
        .then((dataUrl) => {
          this.image = dataUrl;
          this.imageFromInjected = false;
        })
        .catch(err => {
          console.error('Erro ao ler arquivo:', err);
          this.image = null;
        });
    } else {
      console.warn('Nenhum arquivo selecionado.');
      this.image = null;
    }
  }
  

  toggleCamera() {
    this.showWebcan = !this.showWebcan;
    this.webcamImage = undefined;
  }

  handleImage(webcamImage: WebcamImage) {
    this.showWebcan = false;
    if (this.uploadFile?.nativeElement) this.uploadFile.nativeElement.value = '';
    this.webcamImage = webcamImage;

    if (webcamImage?.imageAsDataUrl) {
      this.image = webcamImage.imageAsDataUrl;
      this.imageFromInjected = false;
      console.log('Imagem da webcam:', this.image);
    }
  }

  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  private readFileAsDataUrl(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === 'string') resolve(reader.result);
        else reject(new Error('Reader result is not string'));
      };
      reader.onerror = (err) => reject(err);
      reader.readAsDataURL(file);
    });
  }

  async getBaseUrl(fileList: any) {
    if (!fileList || fileList.length === 0) return null;
    try {
      const data = await this.readFileAsDataUrl(fileList[0]);
      this.image = data;
      return data;
    } catch (err) {
      console.error('Erro em getBaseUrl:', err);
      return null;
    }
  }
}
